import { render, staticRenderFns } from "./DocumentPeopleSender.vue?vue&type=template&id=17c8455e"
import script from "./DocumentPeopleSender.vue?vue&type=script&lang=js"
export * from "./DocumentPeopleSender.vue?vue&type=script&lang=js"
import style0 from "./DocumentPeopleSender.vue?vue&type=style&index=0&id=17c8455e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports